module.exports = __webpack_public_path__ + "images/ico-usergreen.svg?063479e4a3a16bbdafda3fdf4c87e0dd";